import { TemplateRef } from '@angular/core';
import { FormField } from '../form/formField.model';

export interface StepperButton {
    label: string;
    class?: string;
    action: () => void;
    visible?: () => boolean;
    disabled?: () => boolean;
    loading?: () => boolean;
    loadingLabel?: string;
}

export interface StepConfig {
    id: string;
    label: string;
    template: TemplateRef<any>;
    buttons?: StepperButton[];
    visible?: () => boolean;
    canProceed?: () => boolean;
    fields?: FormField[];
    nextLabel?: string;
    onNext?: () => boolean | Promise<boolean>;
}

export interface StepperConfig {
    steps: StepConfig[];
    orientation?: 'horizontal' | 'vertical';
    linear?: boolean;
}

export const DEFAULT_STEPPER_CONFIG: StepperConfig = {
    steps: [],
    orientation: 'horizontal',
    linear: false,
};